import {axios, API} from '@/api'
import enrollments from './enrollments'
import { AxiosError } from 'axios'

export default {
  async getRoles() {
    try {
      const response = await axios.get(API.getRoles(), { headers: enrollments.getAuthHeaders() })
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching roles:', error.response?.data || error.message)
      } else {
        console.error('Unexpected error:', error)
      }
      throw error
    }
  },

  async getFeatureFlags() {
    try {
      const response = await axios.get(API.getFeatureFlags(), { headers: enrollments.getAuthHeaders() });
      return response.data;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async getRole(id) {
    try {
      const response = await axios.get(API.getRole(id));
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching role:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async updateRole(role) {
    try {
      const response = await axios.put(API.updateRole(role.id), {
        name: role.name,
        description: role.description,
        permissions: role.permissions
      });
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error updating role:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async createRole(role) {
    try {
      const response = await axios.post(API.createRole(), {
        name: role.name,
        description: role.description,
        permissions: role.permissions
      });
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error creating role:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async deleteRole(id) {
    try {
      const response = await axios.delete(API.deleteRole(id));
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error deleting role:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  }
}
